import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { UIModule } from '@app/modules/ui/ui.module'
import { Closeable } from '@app/overlays/closeable'
import { MemberService } from '@app/services/member.service'

@Component({
  selector: 'sb-greeting-explainer-modal',
  templateUrl: './greeting-explainer-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GreetingExplainerModalComponent extends Closeable {
  readonly memberService = inject(MemberService)
}
